import React from "react";
import { SimpleGrid, SimpleGridProps } from "@chakra-ui/react";

import { AuxiliaryComponent } from "@constants";
import { ComponentGridItem } from "./ComponentGridItem";

type AuxComponentsDisplayProps = SimpleGridProps & {
  auxiliaryComponents: AuxiliaryComponent[];
};

export function AuxiliaryComponentsGrid({
  auxiliaryComponents,
  ...delegated
}: AuxComponentsDisplayProps) {
  return (
    <SimpleGrid columns={{ sm: 1, md: 3 }} spacing="16px" {...delegated}>
      {auxiliaryComponents.map((auxComponent) => (
        <ComponentGridItem key={auxComponent.id} auxComponent={auxComponent} />
      ))}
    </SimpleGrid>
  );
}
